/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import dayjs from 'dayjs';

// `cd_date_decla_joint_di` est un varchar en base : etcv y enregistre la date
// au format AAAAMMJJ (ex. 20261029), et le back la transmet telle quelle.
// Les composants travaillent en AAAA-MM-JJ, comme pour les autres dates.
const CHAMP = 'dateDeclarationJointDi';

const parser = (date?: string | Date | null) => {
  if (date === null || date === undefined || date === '') {
    return null;
  }

  const parsed =
    typeof date === 'string' && /^\d{8}$/.test(date)
      ? dayjs(`${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6)}`)
      : dayjs(date);

  return parsed.isValid() ? parsed : null;
};

/** Date au format etcv (AAAAMMJJ) → AAAA-MM-JJ. */
export const fromDateEtcv = (date?: string | Date | null): string | null =>
  parser(date)?.format('YYYY-MM-DD') ?? null;

/** Date saisie (AAAA-MM-JJ, Date…) → format etcv AAAAMMJJ. */
export const toDateEtcv = (date?: string | Date | null): string | null =>
  parser(date)?.format('YYYYMMDD') ?? null;

const convertir = <T>(
  convention: T,
  conversion: (date?: string | Date | null) => string | null,
): T => {
  if (!convention || typeof convention !== 'object' || !(CHAMP in convention)) {
    return convention;
  }

  const date = (convention as Record<string, any>)[CHAMP];

  return { ...convention, [CHAMP]: conversion(date) };
};

/** Convention reçue du back : date de déclaration conjointe en AAAA-MM-JJ. */
export const conventionDepuisEtcv = <T>(convention: T): T =>
  convertir(convention, fromDateEtcv);

/** Convention envoyée au back : date de déclaration conjointe en AAAAMMJJ. */
export const conventionVersEtcv = <T>(convention: T): T =>
  convertir(convention, toDateEtcv);
